<div class="wrapper-forgot-password-page">
  <div class="content-forgot-password">
    <div class="back-btn" [routerLink]="PAGES_AND_PATHS.forgotPassword.pagePath">
      <img src="../assets/icons/icon-arrow-left.svg" alt="">
    </div>
    <div class="wrapper-circle-gray-icon">
      <img src="../assets/icons/outline/icon-email-sent.svg" alt="">
    </div>
    <div class="wrapper-header-forgot-password">
      <h1>{{'NEW_TEXT.check_your_email' | translate}}</h1>
      <h6>{{'NEW_TEXT.your_temporary_password_was_successfully_sent_to_your_email_please_login_with_your_temporary_password' | translate}}</h6>
    </div>
    <button class="custom-btn custom-btn--primary xs-mt-12" [routerLink]="PAGES_AND_PATHS.login.pagePath">
      <span>{{'NEW_TEXT.login' | translate}}</span>
    </button>
    <div class="wrapper-label-link">
      <span>{{'NEW_TEXT.didnt_receive_an_email' | translate}}</span>
      <a href="javascript:void(0)" (click)="resendResetPasswordForm()">{{'NEW_TEXT.resend_email' | translate}}</a>
    </div>
  </div>
</div>
